import { BaseResource } from 'e100-data-providers';
import { TRestProvider } from 'dataSources/types/restProvider';
import { TollRoadsChangedResponse, TollRoadsResponse } from './types';

export * from './types';

class TollRoads extends BaseResource {
  path: string = '';

  constructor(provider: TRestProvider) {
    super(provider);
    this.path = '/v1/TollRoad';
  }

  getActualChanges(from?: string): TollRoadsChangedResponse {
    const params: { from?: string } = {};

    if (from) {
      params.from = from;
    }

    return this.getChildResource('changes').getItems(params);
  }

  getRoad(roadKey: string): TollRoadsResponse {
    return this.getItems({
      key: roadKey,
    });
  }
}

export default TollRoads;
